var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9992 19.7173V23.4808C26.0006 23.8302 25.9289 24.176 25.7887 24.4961C25.6484 24.8163 25.4428 25.1036 25.1848 25.3398C24.9268 25.576 24.6223 25.7558 24.2907 25.8678C23.959 25.9797 23.6076 26.0213 23.259 25.9898C19.391 25.5704 15.6755 24.2513 12.4111 22.1385C9.37402 20.2124 6.79908 17.6426 4.86917 14.6115C2.74483 11.3387 1.4228 7.6126 1.0102 3.73494C0.978791 3.38803 1.0201 3.03839 1.1315 2.70828C1.2429 2.37818 1.42196 2.07484 1.65726 1.81758C1.89256 1.56032 2.17896 1.35478 2.49822 1.21404C2.81748 1.0733 3.1626 1.00045 3.51162 1.00012H7.2826C7.89262 0.99413 8.48402 1.20972 8.94656 1.60671C9.40909 2.00371 9.71121 2.55501 9.79658 3.15787C9.95575 4.36227 10.2509 5.54484 10.6765 6.68302C10.8456 7.13204 10.8822 7.62003 10.7819 8.08917C10.6817 8.55831 10.4488 8.98893 10.1108 9.33002L8.51445 10.9232C10.3039 14.0639 12.9095 16.6644 16.0564 18.4503L17.6528 16.857C17.9946 16.5197 18.426 16.2873 18.8961 16.1872C19.3662 16.0872 19.8551 16.1237 20.305 16.2925C21.4455 16.7172 22.6304 17.0118 23.8372 17.1707C24.4478 17.2566 25.0054 17.5636 25.4041 18.0331C25.8027 18.5027 26.0145 19.1021 25.9992 19.7173Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.5fc18fac1922f652edde1b454d8fcadb.svg";
export { ForwardRef as ReactComponent };